var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPin1 = function SvgPin1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 8.24C16.58 3.751 12.63 0 8.25 0 3.86 0-.08 3.752 0 8.24c.16 4.784 4.58 9.967 7.61 12.522a.98.98 0 0 0 1.28 0c3.03-2.555 7.46-7.738 7.61-12.523ZM8.25 19.495c-2.82-2.73-6.72-7.218-6.75-11.256-.07-3.66 3.18-6.777 6.75-6.706C11.82 1.452 15.07 4.58 15 8.24c-.03 4.037-3.93 8.525-6.75 11.255ZM6.75 7.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S9.08 9 8.25 9s-1.5-.67-1.5-1.5Zm1.5-3c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3Z",
    fill: "#000"
  })));
};
export default SvgPin1;